var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Down",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.29289 2.20711C-0.09763 1.81658 -0.09763 1.18342 0.29289 0.79289C0.68342 0.40237 1.31658 0.40237 1.70711 0.79289L8 7.0858L14.2929 0.79289C14.6834 0.40237 15.3166 0.40237 15.7071 0.79289C16.0976 1.18342 16.0976 1.81658 15.7071 2.20711L8.7071 9.2071C8.3166 9.5976 7.68342 9.5976 7.29289 9.2071L0.29289 2.20711Z",
    fill: "#A06056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/Arrow__down.ef47b2120d122b782e022f3ee5f01f88.svg";
export { ForwardRef as ReactComponent };